import { QueryClient } from '@tanstack/react-query';
import { isTerminalError } from './errors';

/**
 * Query defaults for an operations panel.
 *
 * `staleTime` is short but non-zero: the SSE stream is what keeps the screen
 * fresh, and re-fetching on every window focus on top of that just adds load.
 * A contract violation or any 4xx is never retried — retrying a bug produces
 * three identical bugs and hides the error state from the operator.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => !isTerminalError(error) && failureCount < 2,
        retryDelay: (attempt) => Math.min(1_000 * 2 ** attempt, 10_000),
      },
      mutations: {
        // A command carries an idempotency key, but an automatic retry still
        // hides failures from the operator. Retries are always deliberate.
        retry: false,
      },
    },
  });
}
